document.addEventListener("DOMContentLoaded", function () {
  const countries = document.getElementsByClassName('js-certificates-country');
  const isActiveClass = "acc_is-active";
  if (countries) {
    for (let i = 0; i < countries.length; i++) {
      const country = countries[i];
      country.addEventListener('click', function (e) {
        const parent = country.parentNode;
        if (parent.classList.contains(isActiveClass)) {
          parent.classList.remove(isActiveClass);
        } else {
          parent.classList.add(isActiveClass);
        }
      });
    }
  }
});